<template>
  <div class="chart_container p-1">
    <div class="edit_delete_container p-0" v-if="editMode">
      <div class="btn_cont px-2">
        <b-button title="Title" class="p-0 mr-1 color_black mb-0" @click="handleEditTitle" variant="default">
          <font-awesome-icon icon="font" />
        </b-button>
        <b-button title="Edit" class="p-0 mr-1 color_black mb-0" @click="handleEdit" variant="default">
          <font-awesome-icon icon="edit" />
        </b-button>
        <b-button title="Delete" class="p-0 color_black mb-0" @click="handleDelete" variant="default">
          <font-awesome-icon icon="trash-alt" />
        </b-button>
      </div>
    </div>

    <sectionTitleAndLabel :mode="title" v-if="editorTitle" :text="editorTitle" :centerAlign="false">
    </sectionTitleAndLabel>
    <div :style="{ height: editorTitle ? 'calc(100% - 24px)' : '100%' }" style="overflow: scroll">
      <div style="" v-if="showEditor">
        <div ref="toolbar" :id="`toolbar-${id}`">
          <select class="ql-size">
            <option value="small"></option>
            <option selected></option>
            <option value="large"></option>
            <option value="huge"></option>
          </select>
          <button class="ql-bold"></button>
          <button class="ql-italic"></button>
          <button class="ql-underline"></button>
          <button class="ql-script" value="sub"></button>
          <button class="ql-script" value="super"></button>
          <button class="ql-list" value="ordered"></button>
          <button class="ql-list" value="bullet"></button>
          <select class="ql-align">
            <option selected></option>
            <option value="center"></option>
            <option value="right"></option>
            <option value="justify"></option>
          </select>
          <button v-if="selectedReport.data.type == 'MONTHLY'" id="custom-button" @click="openPlaceholderModal()">
            <font-awesome-icon icon="asterisk" />
          </button>
        </div>
        <div ref="editorContainer" :id="id"></div>
        <b-button class="my-4" style="float: right" @click="handleTextEditorUpdate">Update</b-button>
      </div>
      <div v-else>
        <div style="padding: 10px" v-html="htmlData"></div>
      </div>
    </div>
    <b-modal
      v-model="confirmDeleteModal"
      size="md"
      scrollable
      @ok="handleDeleteConfirm()"
      @cancel="confirmDeleteModal = false"
    >
      <div class="p-5">
        <h5>Sei sicuro di eliminarlo?</h5>
      </div>
    </b-modal>
    <b-modal
      cancel-title="Annulla"
      v-model="addTitleEditorModal"
      hide-header
      :body-class="'choose_chartmodal'"
      scrollable
      :header-bg-variant="'light'"
      @ok="addTitleToEditor"
    >
      <div class="p-4">
        <h3>Titolo scheda</h3>
        <b-form ref="titleForm" class="my-5">
          <b-form-group id="fieldset-1">
            <b-form-input v-model="title" type="text" required></b-form-input>
          </b-form-group>
        </b-form>
      </div>
    </b-modal>
    <b-modal
      v-model="selectPlaceholderModal"
      title="Selezionare il placeholder"
      size="lg"
      @ok="addText()"
      @cancel="$bvModal.hide('placeholderModal')"
    >
      <div>
        <label class="mt-1">Selezionare un placeholder</label>
        <multiselect
          v-model="placeholderLabel"
          :options="placeholderList"
          :multiple="false"
          group-values="placeholders"
          group-label="type"
          :group-select="false"
          track-by="value"
          label="text"
        >
        </multiselect>
        <template v-if="selectedPlaceholderType">
          <label class="mt-3">Selezionare un {{ selectedPlaceholderType }}</label>
          <multiselect
            v-model="placeholderValue"
            :options="valueList"
            :multiple="false"
            group-values="items"
            group-label="site"
            :group-select="false"
            track-by="code"
            label="name"
          >
          </multiselect>
        </template>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { makeid } from "@/components/Charts/helpers";
import Quill from "quill";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import sectionTitleAndLabel from "./sectionTitleAndLabel.vue";
import Multiselect from "vue-multiselect";

var moment = require("moment");

export default {
  name: "QuillEditor",
  components: {
    sectionTitleAndLabel,
    Multiselect,
  },
  props: {
    loc: {
      required: true,
      type: Object,
    },
    selectedReport: {
      required: true,
      type: Object,
    },
    editMode: {
      required: true,
      type: Boolean,
    },
  },
  data() {
    return {
      id: makeid(),
      quillEditor: undefined,
      edit: false,
      confirmDeleteModal: false,
      addTitleEditorModal: false,
      selectPlaceholderModal: false,
      title: "",
      newReportFormSubmitted: false,
      isOpenModal: false,
      placeholderLabel: {},
      placeholderValue: {},
      placeholderSelected: "",
      placeholderList: [
        {
          type: "Date",
          placeholders: [
            { text: "Nome del mese", value: "MONTH" },
            { text: "Anno", value: "YEAR" },
            { text: "Anno precedente", value: "YEAR_PREV" },
          ],
        },
        {
          type: "Canali",
          detail: "channel",
          detailName: "canale",
          placeholders: [
            { text: "Scostamento mensile", value: "SCOST" },
            { text: "Scostamento mensile (frase)", value: "SCOST_DESCR" },
            {
              text: "Scostamento mensile su anno precedente",
              value: "SCOST_YEAR",
            },
            {
              text: "Scostamento mensile su anno precedente (frase)",
              value: "SCOST_YEAR_DESCR",
            },
            { text: "Valore mensile", value: "VALUE" },
            { text: "Totale anno solare", value: "VALUE_YEAR" },
            { text: "Totale anno precedente", value: "VALUE_YEAR_PREV" },
            { text: "Differenza mensile su mese precedente", value: "DELTA" },
            {
              text: "Differenza mensile su mese precedente (frase)",
              value: "DELTA_DESCR",
            },
            {
              text: "Differenza mensile su anno precedente",
              value: "DELTA_YEAR",
            },
            {
              text: "Differenza mensile su anno precedente (frase)",
              value: "DELTA_YEAR_DESCR",
            },
            {
              text: "Differenza anno fino al mese corrente",
              value: "DELTA_PARTIAL_YEAR",
            },
            {
              text: "Differenza anno fino al mese corrente (frase)",
              value: "DELTA_PARTIAL_YEAR_DESCR",
            },
            {
              text: "Differenza anno fino al mese corrente (%)",
              value: "DELTA_PARTIAL_YEAR_PERC",
            },
            {
              text: "Differenza anno fino al mese corrente (% frase)",
              value: "DELTA_PARTIAL_YEAR_PERC_DESCR",
            },
          ],
        },
        {
          type: "Costi",
          detail: "channel",
          detailName: "canale",
          placeholders: [
            { text: "Mese", value: "COST" },
            { text: "Totale anno solare", value: "COST_YEAR" },
            { text: "Totale anno precedente", value: "COST_YEAR_PREV" },
            { text: "Mese anno precedente", value: "COST_PREV_MONTHYEAR" },
            {
              text: "Differenza mese su mese anno precedente",
              value: "COST_DELTA_PREV_MONTHYEAR",
            },
            {
              text: "Differenza mese su mese anno precedente (frase)",
              value: "COST_DELTA_PREV_MONTHYEAR_DESCR",
            },
            {
              text: "Differenza anno fino mese corrente",
              value: "COST_DELTA_PREV_YEAR",
            },
            {
              text: "Differenza anno fino mese corrente (frase)",
              value: "COST_DELTA_PREV_YEAR_DESCR",
            },
          ],
        },
        {
          type: "Parametri",
          detail: "parameter",
          detailName: "parametro",
          placeholders: [
            { text: "Valore mensile parametro", value: "VALUE_PARAM" },
            { text: "Scostamento mensile parametro", value: "SCOST_PARAM" },
            {
              text: "Scostamento mensile parametro (frase)",
              value: "SCOST_PARAM_DESCR",
            },
            {
              text: "Scostamento mensile parametro su anno precedente",
              value: "SCOST_PARAM_YEAR",
            },
            {
              text: "Scostamento mensile parametro su anno precedente (frase)",
              value: "SCOST_PARAM_YEAR_DESCR",
            },
            {
              text: "Totale anno precedente (parametro)",
              value: "VALUE_PARAM_YEAR_PREV",
            },
            {
              text: "Differenza mensile parametro su mese precedente",
              value: "DELTA_PARAM",
            },
            {
              text: "Differenza mensile parametro su mese precedente (frase)",
              value: "DELTA_PARAM_DESCR",
            },
            {
              text: "Differenza mensile parametro su anno precedente",
              value: "DELTA_PARAM_YEAR",
            },
            {
              text: "Differenza mensile parametro su anno precedente (frase)",
              value: "DELTA_PARAM_YEAR_DESCR",
            },
            {
              text: "Differenza anno parametro fino al mese corrente",
              value: "DELTA_PARAM_PARTIAL_YEAR",
            },
            {
              text: "Differenza anno parametro fino al mese corrente (frase)",
              value: "DELTA_PARAM_PARTIAL_YEAR_DESCR",
            },
            {
              text: "Differenza anno parametro fino al mese corrente (%)",
              value: "DELTA_PARAM_PARTIAL_YEAR_PERC",
            },
            {
              text: "Differenza anno parametro fino al mese corrente (frase %)",
              value: "DELTA_PARAM_PARTIAL_YEAR_PERC_DESCR",
            },
          ],
        },
        {
          type: "Indicatori",
          detail: "indicator",
          detailName: "indicatore",
          placeholders: [
            { text: "Valore mensile indicatore", value: "VALUE_IND" },
            {
              text: "Valore mensile indicatore (rolling)",
              value: "VALUE_IND_ROLLING",
            },
            { text: "Scostamento mensile indicatore", value: "SCOST_IND" },
            {
              text: "Scostamento mensile indicatore (rolling)",
              value: "SCOST_IND_ROLLING",
            },
            {
              text: "Scostamento mensile indicatore (frase)",
              value: "SCOST_IND_DESCR",
            },
            {
              text: "Scostamento mensile indicatore (rolling, frase)",
              value: "SCOST_IND_ROLLING_DESCR",
            },
            {
              text: "Scostamento mensile indicatore su anno precedente",
              value: "SCOST_IND_YEAR",
            },
            {
              text: "Scostamento mensile indicatore su anno precedente (frase)",
              value: "SCOST_IND_YEAR_DESCR",
            },
            {
              text: "Scostamento mensile indicatore su anno precedente (frase.)",
              value: "SCOST_IND_YEAR_PHRASE",
            },
            {
              text: "Scostamento mensile indicatore su anno precedente (rolling, frase)",
              value: "SCOST_IND_ROLLING_YEAR_PHRASE",
            },
            {
              text: "Scostamento mensile indicatore su anno precedente (rolling.)",
              value: "SCOST_IND_ROLLING_YEAR",
            },
            {
              text: "Scostamento mensile indicatore su anno precedente (rolling, frase)",
              value: "SCOST_IND_ROLLING_YEAR_DESCR",
            },
            {
              text: "Totale anno precedente (indicatore)",
              value: "VALUE_IND_YEAR_PREV",
            },
            {
              text: "Totale anno precedente indicatore (rolling)",
              value: "VALUE_IND_ROLLING_YEAR_PREV",
            },
            {
              text: "Differenza anno fino al mese corrente (%)",
              value: "DELTA_IND_PARTIAL_YEAR_PERC",
            },
            {
              text: "Differenza anno fino al mese corrente (%, frase)",
              value: "DELTA_IND_PARTIAL_YEAR_PERC_DESCR",
            },
          ],
        },
      ],
    };
  },

  mounted() {
    if ((this.editMode && this.edit) || !this.htmlData) {
      this.edit = true;
    }
    this.syncQuillEditorVisibility();
  },

  beforeDestroy() {
    this.resetQuillEditor();
  },

  watch: {
    placeholderLabel() {
      this.placeholderValue = {};
    },
    showEditor(value) {
      if (!value) {
        this.resetQuillEditor();
        return;
      }

      this.syncQuillEditorVisibility();
    },
    editMode() {
      if (!this.editMode) {
        this.edit = false;
      }

      this.syncQuillEditorVisibility();
    },
  },

  methods: {
    openPlaceholderModal() {
      this.placeholderLabel = {};
      this.placeholderValue = {};
      this.placeholderSelected = "";
      this.selectPlaceholderModal = true;
    },
    addText() {
      if (
        this.placeholderLabel &&
        this.placeholderLabel.value &&
        (this.placeholderLabel.value == "MONTH" ||
          this.placeholderLabel.value == "YEAR" ||
          this.placeholderLabel.value == "YEAR_PREV")
      ) {
        this.placeholderSelected = "{ " + this.placeholderLabel.value + " }";
        this.quillEditor.insertText(this.quillEditor.getLength() - 1, this.placeholderSelected);
      } else if (
        this.placeholderLabel &&
        this.placeholderLabel.value &&
        this.placeholderValue &&
        this.placeholderValue.code
      ) {
        this.placeholderSelected = "{ " + this.placeholderLabel.value + ":" + this.placeholderValue.code + " }";
        this.quillEditor.insertText(this.quillEditor.getLength() - 1, this.placeholderSelected);
      } else {
        this.$notify({
          type: "error",
          text: "Selezionare il valore mensile",
          title: "Errore",
        });
      }
    },
    async syncQuillEditorVisibility() {
      if (!this.showEditor) {
        return;
      }

      await this.$nextTick();
      this.initQuillEditor();
    },
    resetQuillEditor() {
      this.quillEditor = undefined;

      if (this.$refs.editorContainer) {
        this.$refs.editorContainer.innerHTML = "";
      }
    },
    initQuillEditor() {
      try {
        const editorContainer = this.$refs.editorContainer;
        const toolbar = this.$refs.toolbar;

        if (!editorContainer || !toolbar) {
          return;
        }

        const activeRoot = this.quillEditor && this.quillEditor.root;
        const hasMountedEditor = activeRoot && activeRoot.isConnected && activeRoot.parentNode === editorContainer;

        if (!hasMountedEditor) {
          this.resetQuillEditor();
          this.quillEditor = new Quill(editorContainer, {
            modules: {
              toolbar,
            },
            placeholder: "",
            theme: "snow",
          });
        }

        this.setDeltaData();
      } catch (error) {
        this.resetQuillEditor();
      }
    },
    async handleTextEditorUpdate() {
      try {
        if (!this.quillEditor) {
          return;
        }
        this.$store.commit("loading");
        var delta = this.quillEditor.getContents();
        let html = this.quillEditor.root.innerHTML;
        let raw = html;
        let editorData = { delta, html, raw };

        let data = {
          editorData,
          ...this.loc,
        };

        let report = _.cloneDeep(this.selectedReport);

        let sectionIndex = report.data.pages[data.pageIndex].sections.findIndex((ele) => {
          return ele.loc.colIndex == data.colIndex && data.rowIndex == ele.loc.rowIndex;
        });

        report.data.pages = report.data.pages.map((page) => {
          page.sections = page.sections.map((section) => {
            if (section.sectionType == "text" && section.editorData) {
              section.editorData.html = section.editorData.raw;
            }
            return section;
          });
          return page;
        });

        report.data.pages[data.pageIndex].sections[sectionIndex].editorData = data.editorData;

        await this.$store.dispatch("report/updateReportBuilder", report);

        this.$emit("updated");

        this.edit = false;
        this.$store.commit("stopLoading");
      } catch (error) {
        console.log(error.message);
      }
    },
    handleEdit() {
      this.edit = !this.edit;

      if (this.showEditor) {
        this.syncQuillEditorVisibility();
      }
    },
    setDeltaData() {
      try {
        if (!this.quillEditor) {
          return;
        }

        let editorSection = this.selectedReport.data.pages[this.loc.pageIndex].sections.find((ele) => {
          return ele.loc.colIndex == this.loc.colIndex && ele.loc.rowIndex == this.loc.rowIndex;
        });

        let deltaData = editorSection && editorSection.editorData ? editorSection.editorData.delta : null;

        if (!deltaData) {
          this.quillEditor.setText("");
          return;
        }

        this.quillEditor.setContents(deltaData);
      } catch (error) {}
    },
    handleDelete() {
      this.confirmDeleteModal = true;
    },
    async handleDeleteConfirm() {
      this.$store.commit("loading");
      let data = {
        ...this.loc,
      };

      let report = _.cloneDeep(this.selectedReport);
      let sectionIndex = report.data.pages[data.pageIndex].sections.findIndex((ele) => {
        return ele.loc.colIndex == data.colIndex && data.rowIndex == ele.loc.rowIndex;
      });
      report.data.pages[data.pageIndex].sections.splice(sectionIndex, 1);
      await this.$store.dispatch("report/updateReportBuilder", report);
      this.$store.commit("stopLoading");
    },
    handleEditTitle() {
      this.addTitleEditorModal = true;
      this.title = this.editorTitle;
    },
    async addTitleToEditor(e) {
      e.preventDefault();
      this.$store.commit("loading");

      let { pageIndex, rowIndex, colIndex } = this.loc;
      let report = _.cloneDeep(this.selectedReport);
      let sectionIndex = report.data.pages[pageIndex].sections.findIndex((ele) => {
        return ele.loc.colIndex == colIndex && rowIndex == ele.loc.rowIndex;
      });

      report.data.pages[pageIndex].sections[sectionIndex].title = this.title;
      await this.$store.dispatch("report/updateReportBuilder", report);
      this.$store.commit("stopLoading");
      this.addTitleEditorModal = false;
    },
  },

  computed: {
    selectedPlaceholderType() {
      let type = "";
      this.placeholderList.forEach((item) => {
        const control = item.placeholders.find((item2) => item2.value == this.placeholderLabel.value);
        if (control) {
          type = item.detailName;
        }
      });
      return type;
    },
    valueList() {
      if (!this.selectedPlaceholderType) {
        return [];
      }

      const sites = Array.isArray(this.$store.state.user.sites) ? this.$store.state.user.sites : [];

      return sites.map((site) => {
        let items = [];

        if (this.selectedPlaceholderType == "canale") {
          items = Array.isArray(site.channels) ? [...site.channels] : [];
        }

        if (this.selectedPlaceholderType == "parametro") {
          items = Array.isArray(site.parameters) ? [...site.parameters] : [];
        }

        if (this.selectedPlaceholderType == "indicatore") {
          items = Array.isArray(site.indicators)
            ? site.indicators.map((indicator) => ({
                ...indicator,
                name: indicator.formula ? indicator.formula.name : indicator.name,
                value: indicator.id != null ? indicator.id.toString() : indicator.value,
                code: indicator.id != null ? indicator.id : indicator.code,
              }))
            : [];
        }

        return {
          site: site.name,
          items,
        };
      });
    },
    htmlData() {
      try {
        let editorData = this.selectedReport.data.pages[this.loc.pageIndex].sections.find((ele) => {
          return ele.loc.colIndex == this.loc.colIndex && ele.loc.rowIndex == this.loc.rowIndex;
        });
        return editorData.editorData.html;
      } catch (error) {
        // console.log("In error",error)
        return null;
      }
    },
    editorTitle() {
      try {
        let editorData = this.selectedReport.data.pages[this.loc.pageIndex].sections.find((ele) => {
          return ele.loc.colIndex == this.loc.colIndex && ele.loc.rowIndex == this.loc.rowIndex;
        });

        return editorData.title ? editorData.title : null;
      } catch (error) {
        return null;
      }
    },
    showEditor() {
      return (this.editMode && this.edit) || !this.htmlData;
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.chart_container {
  position: relative;
}
.edit_delete_container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  top: 3px;
  right: 5px;
  z-index: 100;
  border: 1px solid #e2e2e2;
  /* padding-left: 7px; */
}

.edit_delete_container .btn_cont {
  background: rgba(240, 240, 240, 0.8);
}
</style>



// WEBPACK FOOTER //
// src/components/Reports/editor.vue